<script lang="ts">
  import {getModifierClassName} from '$lib/utils/components';
  import {ButtonModifier} from './enums';

  export let modifiers: ButtonModifier[] = [ButtonModifier.ClrPrimary];
  export let baseClassName = 'btn';
  export let disabled: boolean | undefined = undefined;
  export let href: string | undefined = undefined;
  let klass = '';
  export {klass as class};

  $: modifiersClassName = getModifierClassName(baseClassName, modifiers);
  $: className = [baseClassName, klass, modifiersClassName].filter(Boolean).join(' ');
  $: props = {...$$restProps, class: className};
</script>

{#if !href}
  {#if disabled}
    <button {disabled} {...props}>
      <slot />
    </button>
  {:else}
    <button {...props} on:click on:blur on:focus>
      <slot />
    </button>
  {/if}
{:else}
  <a {href} {...props} on:click on:blur on:focus>
    <slot />
  </a>
{/if}
